import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

import { useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';

import apiService from "../api/ApiService";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form';
import { Close, DateRange, Female, Home, Sell } from '@mui/icons-material';
const moment=require('moment-jalaali');


const EditModalDam=()=>{
    const [activeSensors,setActiveSensor]=useState([])
    const {currentAdmin}=useSelector(state=>state.p.admin)
    const [AllPens,setAllPen]=useState([])
    const {
        control,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm();
    const getPens=async()=>{
        const data=JSON.stringify({
            "skip": -1,
            "take": -1,
            "fromDate": null,
            "toDate": null,
            "isActive": true
          })
          const data2=JSON.stringify({
            "skip": -1,
            "take": -1,
            "fromDate": null,
            "toDate": null,
            "isActive": true,
            "hasCattle":false,
            "farmIds":[currentAdmin?.id]
          })
           
                const res=await apiService.getPens(currentAdmin.id,data)
                const res2=await apiService.getDataFarm(data2)
                setActiveSensor(res2.data.data)
                setAllPen(res.data.data)
              
        
        }
useEffect(()=>{
    getPens()
},[])
    const {isOpenModal,closeModalls,openModalls}=useGlobalContext()
    
    const CreateNewDam=async(data)=>{
                const geregorian=moment(`${data?.birthdate?.year}-${data?.birthdate?.month}-${data?.birthdate?.day}`,'jYYYY-jMM-jDD').format('YYYY-MM-DD')
                const nullabel=data?.sensorNecklaceNumber==='null'?JSON.parse(data?.sensorNecklaceNumber):data?.sensorNecklaceNumber
                const data1=JSON.stringify({...data,birthdate:geregorian,gender:+data?.gender,sensorNecklaceNumber:nullabel});
                const res=await apiService.addNewCattle(data1)
                openModalls()
                window.location.reload()
                
    }
    

    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form className="editModalDamCon Ani AllFFFF" onSubmit={handleSubmit(CreateNewDam)}>
            <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
                <AddToPhotosIcon fontSize='large'/>
           <h4 >افزودن دام</h4>
            
            </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("earTagNumber")}/>
            <label for="" className={'labelSS'}><Sell fontSize='small'/>  شماره گوش</label>
            
        </div>
    
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("bodyNumber")}/>
            <label for="" className={'labelSS'}><Sell fontSize='small'/>  شماره بدن</label>
            
        </div>
        
        {/* {errors?.bodyNumber&&<span className='errMsg'>این مقدار ضروری است</span>} */}
        <div class="inputContainerSS3">
        
                           
                           <Controller
                           control={control}
                           name="birthdate"
                           rules={{ required: true }}
                           render={({ field: { onChange, value } }) => (
                           <DatePicker
                           value={value}
                           onChange={onChange}
                           inputPlaceholder={'تاریخ تولد'}
                             locale='fa'
                             inputClassName='inputSSS'
                             calendarClassName="birthCalender"
                             />)}
                             />
                           <label for="" className={'labelSSS'} > <DateRange fontSize='small'/> تاریخ تولد :  </label>
                              {errors.birthdate&&<span className='errMsg'>این مقدار ضروری است</span>}
                       </div>
                       
                       <div className="SelConn">
        <label for='sele' ><Sell fontSize='small'/> گردنبند:</label>
        <select  id='sele'  name='sele' className="selectInp" {...register("sensorNecklaceNumber",{required:true})}  >
        <option  value={null}>null</option>
            {activeSensors.filter(item=>{
                return item.necklaceNumber!==null&&item.necklaceNumber!==undefined
            }).map((item,index)=>{
                return <option key={index} value={item.necklaceNumber}>{item.necklaceNumber}</option>
            })}
        </select>
        {errors.sensorNecklaceNumber&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        {/* {errors?.sensorId&&<span className='errMsg'>این مقدار ضروری است</span>} */}
        <div className="SelConn">
        <label for='sele' ><Home fontSize='small'/> جایگاه:</label>
        <select  id='sele'  name='sele' className="selectInp" {...register("penId",{required:true})} >
        <option  value={''}>بهاربندی را انتخاب کنید</option>
            {AllPens.map((item,index)=>{
                return <option key={index} value={item.id}>{item.name}</option>
            })}
        </select>
        {errors?.penId&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        
        <div className="SelConn">
        <label for='sele' ><Female fontSize='small'/> جنسیت:</label>
        <select id='sele' name='sele' className="selectInp" {...register("gender",{required:true})}>
            
            <option value={2}>
                نر
            </option>
            <option value={1}>
                ماده
            </option>
        </select>
        {errors.gender&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        
        <button className="EditMOdalBtnForm" type='submit'>
            افزودن  
        </button>
        </form>
        

    </div>
}
export default EditModalDam